import { gql } from 'apollo-angular';
import { dashboardItemFragment } from '../dashboard/dashboard.fragments';

const workspaceDeepLinkCardFragment = gql`
  fragment WorkspaceDeepLinkCard on BaseCard {
    ... on GoalCard {
      id
      workspace {
        id
        dashboard {
          ...DashboardItemFragment
        }
      }
    }
    ... on EventCard {
      id
      workspace {
        id
        dashboard {
          ...DashboardItemFragment
        }
      }
    }
  }
  ${dashboardItemFragment}
`;

export const WorkspaceDeepLinkNodeQuery = gql`
  query WorkspaceDeepLinkNodeQuery($nodeId: ID!) {
    node(id: $nodeId) {
      id

      ... on Workspace {
        id
        dashboard {
          ...DashboardItemFragment
        }
      }

      ...WorkspaceDeepLinkCard

      ... on CardTask {
        id
        card {
          ...WorkspaceDeepLinkCard
        }
      }

      ... on CardComment {
        id
        card {
          ...WorkspaceDeepLinkCard
        }
      }
    }
  }
  ${workspaceDeepLinkCardFragment}
`;
